module.exports = __webpack_public_path__ + "static/media/1.2.98b25bdc.png";